module.exports = __webpack_public_path__ + "static/media/sent.301f519d.svg";